export const HomepageRevampAbTestVariantA = 'A';
export const HomepageRevampAbTestVariantB = 'B';
export const HomepageRevampAbTestVariantC = 'C';
export const HomepageRevampAbTestVariantD = 'D';
